export const CHECKOUT_ROOT_NODE_ID = 'checkout-app';
export const MICRO_APP_NG_CHECKOUT_ROOT_NODE_ID = 'micro-app-ng-checkout';
